import { Component, OnInit } from '@angular/core';
import { GroupsService} from "../groups.service";
import { Group } from "../group.model";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Authority } from "./authority.model";
import { MessagesService } from "../../../messages.service";

@Component({
    selector: 'app-group-detail',
    templateUrl: './group-detail.component.html',
    styleUrls: ['./group-detail.component.css']
})
export class GroupDetailComponent implements OnInit {

    public loading : boolean;
    public authorities: Authority[];
    public authoritiesSelected: Authority[];
    public group: Group;
    public modeEdit: boolean;
    public dropdownList = [];
    public selectedItems = [];
    public dropdownSettings = {};

    constructor(private route: ActivatedRoute, private groupsService: GroupsService, private router: Router,private messagesService:MessagesService) {

    }

    ngOnInit() {
        this.authorities = [];
        this.loadAuthorities();
        const groupId: number = this.route.snapshot.params["id"];
        if (groupId == null) {
            this.modeEdit = false;
            this.group = new Group(null,null);
            this.authoritiesSelected = [];
            this.selectedItems = []; 
        } else {
            this.modeEdit = true;
            this.loadGroup(groupId);
        }
        this.dropdownSettings = { 
                                  singleSelection: false, 
                                  text:"Seleccione una tarea",
                                  selectAllText:'Seleccionar todas',
                                  unSelectAllText:'Deseleccionar todas',
                                  enableSearchFilter: true,
                                  searchPlaceholderText:"Buscar",
                                };            

    }

    
    private loadGroup(groupId: number): void {
        this.loading = true;
        this.groupsService.getGroup(groupId).subscribe(
            data => {
                this.loading = false;
                this.group = data;
                this.authoritiesSelected = this.group.authorities;
                this.selectedItems = this.authoritiesSelected.map(m => ({ id: m.authority, itemName: m.description }));
            },
            error => { this.loading = false; this.checkError(error,"Ha ocurrido un error al cargar el grupo"); }
        );
    }

    private loadAuthorities(): void {
        this.loading = true;
        this.groupsService.getAllAuthorities().subscribe(
            data => {this.loading = false;
                     this.authorities = data;
                     this.dropdownList = this.authorities.map(m => ({ id: m.authority, itemName: m.description }));
            },
            error => { this.loading = false; this.checkError(error,"Ha ocurrido un error al cargar las tareas"); }
        );
    }

    save() {
        this.loading = true;
        let errors = this.validateGroup(this.group);
        if (errors.length > 0) {
            this.loading = false;
             this.messagesService.viewWarnings(errors);
        } else {
            this.group.authorities = this.selectedItems.map(m => new Authority(m.id,m.itemName));
            this.groupsService.save(this.group).subscribe(
                data => { this.loading = false; this.router.navigate(['./groups']) },
                error => { this.loading = false; this.checkError(error,"Ha ocurrido un error al gurdar el perfil"); }
            );
        }
    }


    private validateGroup(pGroup: Group): string[] {
        let errors: string[] = [];
        if (pGroup.description == null || pGroup.description.trim().length == 0) {
            errors.push('Debe ingresar la descripción');
        }
        if (this.selectedItems.length == 0) {
            errors.push('Debe seleccionar una tarea');
        }
        return errors;
    }


    private checkError(error: any, defaultMessage: string) {
        this.messagesService.checkError(error,defaultMessage);
    }

}
